import { useState,useEffect } from 'react';
import { Box, Card, Checkbox, Grid, Typography, useTheme } from '@mui/material'
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import RadioButtonUncheckedOutlinedIcon from '@mui/icons-material/RadioButtonUncheckedOutlined';
import SpeedIcon from '@mui/icons-material/Speed';
import AttachMoneyIcon from '@mui/icons-material/AttachMoney';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
const CardItemServicios = ({
    item,
    servicioSelect,
    setServicioSelect,
    coberturaMaxima,
    permisoEsp,
    disabledPrefa = false,
    permisoPrefa
}) => {
    const theme = useTheme();
    const isDark = theme.palette.mode === 'dark';
    const [mbBajada, setmbBajada] = useState(0)
    const [precio, setPrecio] = useState(0)
    useEffect(() => {
        const splite = item?.bajada?.split('.')
        if(splite?.length > 0){
            setmbBajada(splite[0])
        }
    }, [item])
    const onClickCard = () =>{
        if(coberturaMaxima >= mbBajada || permisoEsp){
            setServicioSelect({...item,prefactibilidad: 'POSITIVA'})
        }else if(!disabledPrefa && permisoPrefa){
            if(item?.tipo?.trim() === 'PY'){
                setServicioSelect({...item, prefactibilidad: 'NEGATIVA'})
            }
        }
    }
    useEffect(() => {
        if(item?.precio){
            const numero = Number(item?.precio)
            if(!isNaN(numero)){
                setPrecio(Math.round(numero * 100) / 100);
            }
        }
    }, [item])

    const isSelected = servicioSelect?.cod_producto === item?.cod_producto;
    const isPymes = item?.tipo_descripcion === 'NUBI PyMES';
    const isEnabled = coberturaMaxima >= mbBajada || permisoEsp || (!disabledPrefa && permisoPrefa && item?.tipo?.trim() === 'PY');

    return (
        <Card
            sx={{
                background: isSelected
                    ? isPymes
                        ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                        : 'linear-gradient(135deg, #1e88e5 0%, #1565c0 100%)'
                    : isEnabled
                        ? isPymes
                            ? isDark
                                ? 'linear-gradient(135deg, #2d2418 0%, #332a1c 100%)'
                                : 'linear-gradient(135deg, #fff8f0 0%, #fff5e8 100%)'
                            : isDark
                                ? 'linear-gradient(135deg, #1e293b 0%, #1a2332 100%)'
                                : 'linear-gradient(135deg, #fafbfd 0%, #f5f8fc 100%)'
                        : isDark
                            ? 'linear-gradient(135deg, #1a1e26 0%, #151920 100%)'
                            : 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
                border: isSelected
                    ? isPymes
                        ? '2px solid #ffb84d'
                        : '2px solid #42a5f5'
                    : isEnabled
                        ? isPymes
                            ? isDark ? '2px solid #5c4a2e' : '2px solid #ffe4c4'
                            : isDark ? '2px solid #2d4260' : '2px solid #dce8f5'
                        : isDark ? '2px solid #2d3340' : '2px solid #dee2e6',
                borderRadius: '16px',
                boxShadow: isSelected
                    ? isPymes
                        ? '0 8px 24px rgba(255, 159, 67, 0.25), 0 0 0 1px rgba(255, 184, 77, 0.1) inset'
                        : '0 8px 24px rgba(30, 136, 229, 0.25), 0 0 0 1px rgba(66, 165, 245, 0.1) inset'
                    : isEnabled
                        ? isPymes
                            ? isDark ? '0 2px 10px rgba(255, 159, 67, 0.12)' : '0 2px 10px rgba(255, 159, 67, 0.08)'
                            : isDark ? '0 2px 10px rgba(100, 150, 200, 0.12)' : '0 2px 10px rgba(100, 150, 200, 0.08)'
                        : isDark ? '0 2px 8px rgba(0,0,0,0.2)' : '0 2px 8px rgba(0,0,0,0.06)',
                mt: 1.5,
                transition: 'all 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
                cursor: isEnabled ? 'pointer' : 'not-allowed',
                '&:hover':{
                    transform: isEnabled ? 'translateY(-4px)' : 'none',
                    boxShadow: isSelected
                        ? isPymes
                            ? '0 12px 32px rgba(255, 159, 67, 0.35), 0 0 0 1px rgba(255, 184, 77, 0.2) inset'
                            : '0 12px 32px rgba(30, 136, 229, 0.35), 0 0 0 1px rgba(66, 165, 245, 0.2) inset'
                        : isEnabled
                            ? isPymes
                                ? isDark
                                    ? '0 4px 18px rgba(255, 159, 67, 0.2), 0 0 0 2px #5c4a2e'
                                    : '0 4px 18px rgba(255, 159, 67, 0.12), 0 0 0 2px #ffdbb8'
                                : isDark
                                    ? '0 4px 18px rgba(100, 150, 200, 0.2), 0 0 0 2px #2d4260'
                                    : '0 4px 18px rgba(100, 150, 200, 0.12), 0 0 0 2px #d4e4f7'
                            : isDark ? '0 2px 8px rgba(0,0,0,0.3)' : '0 2px 8px rgba(0,0,0,0.06)'
                },
                position: 'relative',
                overflow: 'hidden'
            }}
            onClick={()=>onClickCard()}
        >
            {/* Indicador de selección - Barra superior con brillo */}
            {isSelected && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        height: '5px',
                        background: isPymes
                            ? 'linear-gradient(90deg, #ffb84d 0%, #ffc870 50%, #ffb84d 100%)'
                            : 'linear-gradient(90deg, #42a5f5 0%, #64b5f6 50%, #42a5f5 100%)',
                        backgroundSize: '200% 100%',
                        animation: 'shimmer 2s ease-in-out infinite',
                        zIndex: 1,
                        '@keyframes shimmer': {
                            '0%': { backgroundPosition: '-200% 0' },
                            '100%': { backgroundPosition: '200% 0' }
                        }
                    }}
                />
            )}

            {/* Badge de Deshabilitado Mejorado */}
            {!(coberturaMaxima >= mbBajada || permisoEsp || (isSelected && servicioSelect?.prefactibilidad === 'NEGATIVA')) && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 14,
                        right: 14,
                        px: 2,
                        py: 0.75,
                        background: 'linear-gradient(135deg, #ff6b6b 0%, #ee5a6f 100%)',
                        borderRadius: '20px',
                        boxShadow: '0 4px 12px rgba(255, 107, 107, 0.4)',
                        zIndex: 2,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 0.5
                    }}
                >
                    <Box
                        sx={{
                            width: 6,
                            height: 6,
                            borderRadius: '50%',
                            backgroundColor: '#fff',
                            animation: 'pulse 2s ease-in-out infinite',
                            '@keyframes pulse': {
                                '0%, 100%': { opacity: 1 },
                                '50%': { opacity: 0.4 }
                            }
                        }}
                    />
                    <Typography
                        sx={{
                            color: '#fff',
                            fontSize: 10,
                            fontWeight: 700,
                            textTransform: 'uppercase',
                            letterSpacing: '0.8px'
                        }}
                    >
                        Sin Cobertura
                    </Typography>
                </Box>
            )}

            <Grid container spacing={1.5} sx={{p: {xs: 1.5, sm: 2}}}>
                {/* Checkbox */}
                <Grid item xs={2} sm={1.5} md={1} display='flex' justifyContent='center' alignItems='center'>
                    <Checkbox
                        checked={isSelected}
                        icon={
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    border: isPymes
                                        ? isDark ? '3px solid #5c4a2e' : '3px solid #ffdbb8'
                                        : isDark ? '3px solid #2d4260' : '3px solid #d4e4f7',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                                    backgroundColor: isPymes
                                        ? isDark ? '#2d2418' : '#fff8f0'
                                        : isDark ? '#1a2a3e' : '#f0f6fc',
                                    '&:hover': {
                                        borderColor: isPymes
                                            ? '#ffb84d'
                                            : '#64b5f6',
                                        backgroundColor: isPymes
                                            ? 'rgba(255, 184, 77, 0.12)'
                                            : 'rgba(100, 181, 246, 0.12)',
                                        transform: 'scale(1.1)'
                                    }
                                }}
                            >
                                <RadioButtonUncheckedOutlinedIcon sx={{fontSize: 0}} />
                            </Box>
                        }
                        checkedIcon={
                            <Box
                                sx={{
                                    width: 28,
                                    height: 28,
                                    background: isPymes
                                        ? 'linear-gradient(135deg, #ff9f43 0%, #ffb84d 100%)'
                                        : 'linear-gradient(135deg, #1e88e5 0%, #42a5f5 100%)',
                                    borderRadius: '50%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    boxShadow: isPymes
                                        ? '0 4px 12px rgba(255, 159, 67, 0.5), 0 0 0 3px rgba(255, 184, 77, 0.2)'
                                        : '0 4px 12px rgba(30, 136, 229, 0.5), 0 0 0 3px rgba(66, 165, 245, 0.2)',
                                    animation: 'checkPulse 0.5s cubic-bezier(0.4, 0, 0.2, 1)'
                                }}
                            >
                                <CheckCircleIcon sx={{color: '#fff', fontSize: 20}} />
                            </Box>
                        }
                        sx={{
                            p: 0,
                            '&:hover': {
                                backgroundColor: 'transparent'
                            }
                        }}
                    />
                </Grid>

                {/* Contenido Principal */}
                <Grid item xs={10} sm={6.5} md={7}>
                    <Box display='flex' flexDirection='column' gap={0.4}>
                        {/* Tipo/Categoría con Icono y Badge */}
                        <Box display='flex' alignItems='center' gap={0.8}>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    width: 24,
                                    height: 24,
                                    borderRadius: '8px',
                                    background: isSelected
                                        ? 'rgba(255, 255, 255, 0.25)'
                                        : isEnabled
                                            ? isPymes
                                                ? isDark
                                                    ? 'linear-gradient(135deg, #3d2e14 0%, #4a3618 100%)'
                                                    : 'linear-gradient(135deg, #fff5e8 0%, #ffeccc 100%)'
                                                : isDark
                                                    ? 'linear-gradient(135deg, #1a2a3e 0%, #1e3048 100%)'
                                                    : 'linear-gradient(135deg, #e8f2fa 0%, #d9e9f7 100%)'
                                            : isDark ? 'rgba(100, 100, 100, 0.15)' : 'rgba(158, 158, 158, 0.15)'
                                }}
                            >
                                <SignalCellularAltIcon 
                                    sx={{
                                        fontSize: 14,
                                        color: isSelected
                                            ? '#fff'
                                            : isEnabled
                                                ? isPymes
                                                    ? isDark ? '#e0b054' : '#d4940f'
                                                    : isDark ? '#90caf9' : '#5b8fc4'
                                                : isDark ? '#64748b' : '#9e9e9e'
                                    }}
                                />
                            </Box>
                            <Typography 
                                sx={{
                                    color: isSelected
                                        ? 'rgba(255, 255, 255, 0.95)'
                                        : isEnabled
                                            ? isPymes
                                                ? isDark ? '#e0b054' : '#d4940f'
                                                : isDark ? '#90caf9' : '#6b95c1'
                                            : isDark ? '#64748b' : '#9e9e9e',
                                    fontSize: {xs: 11, sm: 12},
                                    fontWeight: 700,
                                    letterSpacing: '1px',
                                    textTransform: 'uppercase'
                                }} 
                                variant='caption'
                            >
                                {item?.tipo_descripcion}
                            </Typography>
                        </Box>

                        {/* Nombre del servicio */}
                        <Typography 
                            sx={{
                                color: isSelected
                                    ? '#fff'
                                    : isEnabled
                                        ? isDark ? '#e0e0e0' : '#202124'
                                        : isDark ? '#546478' : '#757575',
                                fontWeight: 700,
                                fontSize: {xs: 15, sm: 17, md: 18},
                                lineHeight: 1.3
                            }} 
                            variant='h4'
                        >
                            {item?.nombre}
                        </Typography>

                        {/* Alerta Sin Cobertura */}
                        {isSelected && servicioSelect?.prefactibilidad === 'NEGATIVA' && (
                            <Box
                                sx={{
                                    mt: 0.8,
                                    p: 1,
                                    backgroundColor: isDark ? '#3b1c1c' : '#fff5f5',
                                    border: isDark ? '1px solid #7c3535' : '1px solid #feb2b2',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    flexDirection: 'column',
                                    gap: 0.3
                                }}
                            >
                                <Box display='flex' alignItems='center' gap={0.5}>
                                    <Box
                                        sx={{
                                            width: 16,
                                            height: 16,
                                            borderRadius: '50%',
                                            backgroundColor: '#fc8181',
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            color: '#fff',
                                            fontSize: 10,
                                            fontWeight: 700
                                        }}
                                    >
                                        !
                                    </Box>
                                    <Typography 
                                        sx={{
                                            color: isDark ? '#fc8181' : '#c53030',
                                            fontWeight: 700,
                                            fontSize: {xs: 10, sm: 11}
                                        }}
                                    >
                                        SIN COBERTURA
                                    </Typography>
                                </Box>
                                <Typography 
                                    sx={{
                                        color: isDark ? '#fca5a5' : '#742a2a',
                                        fontSize: {xs: 9, sm: 10},
                                        lineHeight: 1.4,
                                        ml: 2.5
                                    }}
                                >
                                    Se solicitará un estudio de prefactibilidad en RF y FO.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </Grid>

                {/* Velocidad y Precio */}
                <Grid 
                    item 
                    xs={12} 
                    sm={4} 
                    md={4} 
                    display='flex' 
                    justifyContent={{xs: 'space-between', sm: 'flex-end'}} 
                    alignItems='center' 
                    gap={1.5}
                >
                    {/* Velocidad con Icono - Diseño Mejorado */}
                    <Box
                        sx={{
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                            justifyContent: 'center',
                            p: {xs: 1.5, sm: 2},
                            background: isSelected
                                ? 'rgba(255, 255, 255, 0.15)'
                                : isEnabled
                                    ? isPymes
                                        ? isDark
                                            ? 'linear-gradient(135deg, #2d2418 0%, #332a1c 100%)'
                                            : 'linear-gradient(135deg, #fff8f0 0%, #fff0db 100%)'
                                        : isDark
                                            ? 'linear-gradient(135deg, #1a2a3e 0%, #1e3048 100%)'
                                            : 'linear-gradient(135deg, #f0f6fc 0%, #e8f1fb 100%)'
                                    : isDark
                                        ? 'linear-gradient(135deg, #1a1e26 0%, #1e2230 100%)'
                                        : 'linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%)',
                            borderRadius: '14px',
                            minWidth: {xs: 85, sm: 95},
                            border: isSelected
                                ? '2px solid rgba(255, 255, 255, 0.3)'
                                : isEnabled
                                    ? isPymes
                                        ? isDark ? '2px solid #5c4a2e' : '2px solid #ffdbb8'
                                        : isDark ? '2px solid #2d4260' : '2px solid #d4e4f7'
                                    : isDark ? '2px solid #2d3340' : '2px solid #e9ecef',
                            position: 'relative',
                            overflow: 'hidden',
                            boxShadow: isSelected
                                ? '0 4px 12px rgba(255, 255, 255, 0.1)'
                                : isEnabled
                                    ? isPymes
                                        ? isDark ? '0 2px 8px rgba(255, 159, 67, 0.1)' : '0 2px 8px rgba(255, 159, 67, 0.06)'
                                        : isDark ? '0 2px 8px rgba(100, 150, 200, 0.1)' : '0 2px 8px rgba(100, 150, 200, 0.06)'
                                    : 'none'
                        }}
                    >
                        {/* Icono de fondo decorativo con efecto de brillo */}
                        <SpeedIcon 
                            sx={{
                                position: 'absolute',
                                top: -12,
                                right: -12,
                                fontSize: 60,
                                color: isSelected
                                    ? 'rgba(255, 255, 255, 0.12)'
                                    : isEnabled
                                        ? isPymes
                                            ? isDark ? 'rgba(255, 159, 67, 0.12)' : 'rgba(255, 159, 67, 0.08)'
                                            : isDark ? 'rgba(100, 150, 200, 0.12)' : 'rgba(100, 150, 200, 0.08)'
                                        : isDark ? 'rgba(100, 116, 139, 0.08)' : 'rgba(158, 158, 158, 0.05)',
                                transform: 'rotate(15deg)',
                                transition: 'all 0.3s ease'
                            }}
                        />
                        <Box display='flex' alignItems='center' gap={0.5} sx={{mb: 0.3, position: 'relative', zIndex: 1}}>
                            <SpeedIcon 
                                sx={{
                                    fontSize: 14,
                                    color: isSelected
                                        ? 'rgba(255, 255, 255, 0.75)'
                                        : isEnabled
                                            ? isPymes
                                                ? isDark ? '#e0b054' : '#d4940f'
                                                : isDark ? '#90caf9' : '#6b95c1'
                                            : isDark ? '#546478' : '#bdbdbd'
                                }}
                            />
                            <Typography 
                                sx={{
                                    color: isSelected
                                        ? 'rgba(255, 255, 255, 0.75)'
                                        : isEnabled
                                            ? isPymes
                                                ? isDark ? '#e0b054' : '#d9a430'
                                                : isDark ? '#90caf9' : '#7b9cb8'
                                            : isDark ? '#546478' : '#9e9e9e',
                                    fontSize: {xs: 9, sm: 10},
                                    fontWeight: 600,
                                    textTransform: 'uppercase',
                                    letterSpacing: '0.8px'
                                }}
                            >
                                Velocidad
                            </Typography>
                        </Box>
                        <Box display='flex' alignItems='baseline' gap={0.4} sx={{position: 'relative', zIndex: 1}}>
                            <Typography 
                                sx={{
                                    color: isSelected
                                        ? '#fff'
                                        : isEnabled
                                            ? isDark ? '#e0e0e0' : '#202124'
                                            : isDark ? '#546478' : '#9e9e9e',
                                    fontWeight: 800,
                                    fontSize: {xs: 26, sm: 27, md: 29},
                                    lineHeight: 1
                                }}
                            >
                                {mbBajada}
                            </Typography>
                            <Typography 
                                sx={{
                                    fontSize: {xs: 12, sm: 13},
                                    fontWeight: 600,
                                    color: isSelected
                                        ? 'rgba(255, 255, 255, 0.85)'
                                        : isEnabled
                                            ? isPymes
                                                ? isDark ? '#e0b054' : '#e0b054'
                                                : isDark ? '#90caf9' : '#8ba8c5'
                                            : isDark ? '#546478' : '#bdbdbd',
                                    mb: 0.3
                                }}
                            >
                                {item?.unidad_bajada}
                            </Typography>
                        </Box>
                    </Box>

                    {/* Precio con Icono - Diseño Premium */}
                    {precio > 0 && (
                        <Box
                            sx={{
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                justifyContent: 'center',
                                p: {xs: 1.5, sm: 2},
                                background: isSelected
                                    ? isPymes
                                        ? 'linear-gradient(135deg, #ffb84d 0%, #ffb84d 50%, #ffb84d 100%)'
                                        : 'linear-gradient(135deg, #42a5f5 0%, #64b5f6 50%, #42a5f5 100%)'
                                    : isEnabled
                                        ? isPymes
                                            ? 'linear-gradient(135deg, #ff9f43 0%, #ff8008 100%)'
                                            : 'linear-gradient(135deg, #1e88e5 0%, #1976d2 100%)'
                                        : isDark
                                            ? 'linear-gradient(135deg, #3d4a5c 0%, #334155 100%)'
                                            : 'linear-gradient(135deg, #ced4da 0%, #adb5bd 100%)',
                                borderRadius: '14px',
                                boxShadow: isSelected
                                    ? isPymes
                                        ? '0 6px 20px rgba(255, 184, 77, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2) inset'
                                        : '0 6px 20px rgba(66, 165, 245, 0.4), 0 0 0 1px rgba(255, 255, 255, 0.2) inset'
                                    : isEnabled
                                        ? isPymes
                                            ? '0 4px 16px rgba(255, 159, 67, 0.35)'
                                            : '0 4px 16px rgba(30, 136, 229, 0.35)'
                                        : isDark
                                            ? '0 2px 8px rgba(0, 0, 0, 0.3)'
                                            : '0 2px 8px rgba(173, 181, 189, 0.3)',
                                minWidth: {xs: 85, sm: 95},
                                position: 'relative',
                                overflow: 'hidden',
                                backgroundSize: isSelected ? '200% 100%' : '100% 100%',
                                animation: isSelected ? 'gradientShift 3s ease infinite' : 'none',
                                '@keyframes gradientShift': {
                                    '0%, 100%': { backgroundPosition: '0% 50%' },
                                    '50%': { backgroundPosition: '100% 50%' }
                                }
                            }}
                        >
                            {/* Icono de fondo decorativo mejorado */}
                            <AttachMoneyIcon 
                                sx={{
                                    position: 'absolute',
                                    top: -10,
                                    right: -10,
                                    fontSize: 60,
                                    color: 'rgba(255, 255, 255, 0.12)',
                                    transform: 'rotate(-15deg)',
                                    transition: 'all 0.3s ease'
                                }}
                            />
                            <Box display='flex' alignItems='center' gap={0.5} sx={{mb: 0.2, position: 'relative', zIndex: 1}}>
                                <AttachMoneyIcon 
                                    sx={{
                                        fontSize: 14,
                                        color: 'rgba(255, 255, 255, 0.9)'
                                    }}
                                />
                                <Typography 
                                    sx={{
                                        color: 'rgba(255, 255, 255, 0.9)',
                                        fontSize: {xs: 9, sm: 10},
                                        fontWeight: 600,
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.8px'
                                    }}
                                >
                                    Precio
                                </Typography>
                            </Box>
                            <Box display='flex' alignItems='baseline' gap={0.3} sx={{position: 'relative', zIndex: 1}}>
                                <Typography 
                                    sx={{
                                        color: '#fff',
                                        fontSize: {xs: 11, sm: 12},
                                        fontWeight: 700,
                                        mb: 0.4
                                    }}
                                >
                                    $
                                </Typography>
                                <Typography 
                                    sx={{
                                        color: '#fff',
                                        fontWeight: 800,
                                        fontSize: {xs: 22, sm: 25, md: 27},
                                        lineHeight: 1
                                    }}
                                >
                                    {precio}
                                </Typography>
                            </Box>
                            <Typography 
                                sx={{
                                    color: 'rgba(255, 255, 255, 0.85)',
                                    fontSize: {xs: 9, sm: 10},
                                    fontWeight: 500,
                                    position: 'relative',
                                    zIndex: 1
                                }}
                            >
                                /mes
                            </Typography>
                        </Box>
                    )}
                </Grid>
            </Grid>

            {/* Animación CSS */}
            <style>
                {`
                    @keyframes checkPulse {
                        0% { transform: scale(0.8); }
                        50% { transform: scale(1.1); }
                        100% { transform: scale(1); }
                    }
                `}
            </style>
        </Card>
    )
}

export default CardItemServicios